export enum AdminAction {
  REJECTED = 0,
  CHANGED = 1,
  APPROVED = 2,
  PENDING = 3,
  MANUAL = 4,
}

export enum EndReason {
  UNKNOWN = 0,
  TIMEOUT = 1,
  MANUAL = 2,
}
